import type { IIntegrations } from "store/integrationsStore";

export type IIntegrationsList = {
    name: string;
    title: string;
    icon: React.ReactNode;
    subtitle: string;
    isConnected: boolean;
    disabled: boolean;
    integrations?: IIntegrations[];
    onConnect: () => void;
    onDisconnect: ((e: React.MouseEvent) => void) | null;
    onOpenDetails: () => void;
}[];

export type TIntegrationName = "google" | "sage" | "ebp" | "dilisco" | "interforum" | "bexio" | "docoon";

export interface TDocoonConnectModal {
    open: boolean;
}

export interface TDisconnectModal {
    open: boolean;
    integrationName: string;
    warningText?: string;
    id: number | null;
}

export interface TDetailsDrawer {
    open: boolean;
    integrationName: string;
    integrations: IIntegrations[];
    logo: React.ReactNode;
}

export type TInitialState = {
    disconnectModal: TDisconnectModal;
    detailsDrawer: TDetailsDrawer;
    docoonConnectModal: TDocoonConnectModal;
};

export const initialState: TInitialState = {
    disconnectModal: {
        open: false,
        integrationName: "",
        warningText: "",
        id: null,
    },
    detailsDrawer: {
        open: false,
        integrationName: "",
        integrations: [],
        logo: undefined,
    },
    docoonConnectModal: {
        open: false,
    },
};
